import React from 'react';

import PropTypes from 'prop-types';

import { undoDelete } from 'bundles/discussions/actions/DropdownActions';

import _t from 'i18n!nls/discussions';

import 'css!./__styles__/SoftDelete';

class SoftDelete extends React.Component {
  static propTypes = {
    hideUndoDelete: PropTypes.bool,
    entry: PropTypes.object.isRequired,
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
  };

  state = {
    showError: false,
  };

  undoDeleteButton = React.createRef<HTMLButtonElement>();

  componentDidMount() {
    this.undoDeleteButton.current?.focus();
  }

  handleUndoDelete = (e: $TSFixMe) => {
    e.preventDefault();
    this.context.executeAction(undoDelete, {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'entry' does not exist on type 'Readonly<... Remove this comment to see the full error message
      post: this.props.entry,
      handleFailure: this.handleError,
      onSuccess: () => {},
    });
  };

  handleError = (error: $TSFixMe) => {
    this.setState({
      showError: true,
    });
  };

  render() {
    const error = (
      <div ref="error" className="c-soft-delete-error c-error-text">
        {_t('Error undoing delete, please reload the page and try again')}
      </div>
    );

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'entry' does not exist on type 'Readonly<... Remove this comment to see the full error message
    const { entry } = this.props;
    const deletedByCreator = entry.state.deleted && entry.state.deleted.userId === entry.creator?.userId;
    const deletedByText = deletedByCreator
      ? _t('This post has been deleted by its creator')
      : _t('This post has been deleted by a moderator');

    const undoDeleteComponent = (
      <div className="c-soft-delete-header">
        <span ref="message">
          {deletedByText}
          &nbsp;·&nbsp;
        </span>
        <button ref={this.undoDeleteButton} className="button-link" onClick={this.handleUndoDelete}>
          {_t('Undo Delete')}
        </button>
      </div>
    );

    let className = 'c-soft-delete';
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'hideUndoDelete' does not exist on type '... Remove this comment to see the full error message
    if (this.props.hideUndoDelete) {
      className += ' c-soft-delete-clickable';
    }

    return (
      <div className="rc-SoftDelete">
        <div className={className} role="alert">
          {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'hideUndoDelete' does not exist on type '... Remove this comment to see the full error message */}
          {!this.props.hideUndoDelete && !this.state.showError && undoDeleteComponent}
          {this.state.showError && error}
        </div>
      </div>
    );
  }
}

export default SoftDelete;
